"use client";

import React, { useState, useEffect, useRef } from "react";
import Link from "next/link";
import Image from "next/image";
import { IoIosArrowDown } from "react-icons/io";
import { getFooterData, getNavigationData } from "../utils/services/navigation";
import { usePathname } from "next/navigation";

import { Dropdown, Space } from "antd";
import { useMultiLanguages } from "../utils/multiLanguage/MultiLanguageContext";

const Header = () => {
  const sidebarRef = useRef(null);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [nav, setNav] = useState([]);
  const [isMobile, setIsMobile] = useState(false);

  const [whatsapp, setWhatsapp] = useState("");

  const pathname = usePathname();
  const isArahKebijakan = pathname === "/arah-kebijakan";
  const isHome = pathname === "/";
  const isProfil = pathname.startsWith("/profil");
  const isNews = pathname.startsWith("/news");
  const showLanguageSwitcher = ["/profil", "/news", "/berita"].some((route) =>
    pathname.startsWith(route)
  );
  const { setLocale, localeFlag, locale } = useMultiLanguages();

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  const closeSidebar = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const scrollThreshold = 150;

      if (scrollTop > scrollThreshold) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // On mobile home page, always show scrolled state
  const effectiveIsScrolled = (isHome && isMobile) || isScrolled;

  useEffect(() => {
    const getNavigation = async () => {
      try {
        const response = await getNavigationData();
        const sortedNav = [...response.data].sort(
          (a, b) => a.urutan - b.urutan
        );
        setNav(sortedNav);
      } catch (error) {
        console.error("Error getting data:", error);
      }
    };

    getNavigation();
  }, []);

  useEffect(() => {
    const getWhatsapp = async () => {
      try {
        const response = await getFooterData();
        setWhatsapp(response.data.no_whatsapp);
      } catch (error) {
        console.error("Error getting data:", error);
      }
    };

    getWhatsapp();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1024);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const items = [
    {
      key: "id",
      label: (
        <div
          className="cursor-pointer"
          style={{ display: "flex", alignItems: "center", gap: 8 }}
        >
          <div className="relative w-7 h-7">
            <Image src={"/image/indonesia.svg"} fill alt="indonesia" />
          </div>
          <div>
            <div style={{ fontWeight: 600, fontSize: 14 }}>Indonesia (ID)</div>
            <div style={{ fontSize: 12, color: "#8c8c8c" }}>
              Bahasa Indonesia
            </div>
          </div>
        </div>
      ),
      className: "dropdown-item-selected", // optional, to apply highlight
    },
    {
      key: "en",
      label: (
        <div
          className="cursor-pointer"
          style={{ display: "flex", alignItems: "center", gap: 8 }}
        >
          <div className="relative w-7 h-7">
            <Image src={"/image/united-kingdom.svg"} fill alt="indonesia" />
          </div>
          <div>
            <div style={{ fontWeight: 600, fontSize: 14 }}>English (EN)</div>
            <div style={{ fontSize: 12, color: "#8c8c8c" }}>United States</div>
          </div>
        </div>
      ),
    },
  ];

  return (
    <>
      <header
        className={`${
          isArahKebijakan ? "hidden" : "flex"
        } flex-row ${isHome && isMobile ? "sticky" : "fixed"} top-0 z-40 py-4 px-5 lg:px-20 w-full items-center justify-between min-h-20 ${
          effectiveIsScrolled
            ? "bg-white drop-shadow-lg text-cust-blue"
            : "bg-gradient-to-b from-cust-black/70 from-10% to-transparent"
        } transition-all duration-300 ease-in-out`}
      >
        {/* {isMobile && ( */}
        <div className="flex flex-row justify-between items-center w-full">
          <div className="flex items-center gap-5">
            <button
              className={`${
                effectiveIsScrolled ? "text-gray-700" : "text-white"
              } focus:outline-none cursor-pointer`}
              onClick={toggleSidebar}
              aria-label="Toggle Sidebar"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16M4 18h16"
                ></path>
              </svg>
            </button>
          </div>
          <Link className="flex justify-center cursor-pointer" href="/">
            <Image
              src={
                locale === "id"
                  ? effectiveIsScrolled
                    ? "/image/logoUmkm4.svg"
                    : "/image/logoUmkm4_white.svg"
                  : effectiveIsScrolled
                  ? "/image/logoUmkm6.svg"
                  : "/image/logoUmkm6_white.svg"
              }
              alt="UMKM Logo"
              width={100}
              height={100}
              className="w-52"
              priority
            />
          </Link>
          {/* {showLanguageSwitcher ? ( */}
            <div className="flex flex-row justify-end items-center w-auto gap-5">
              <div className="flex flex-row gap-2 items-center cursor-pointer">
                <Dropdown
                  menu={{
                    items,
                    onClick: ({ key }) => setLocale(key),
                  }}
                >
                  <Space>
                    <Image
                      src={localeFlag}
                      width={24}
                      height={24}
                      alt="indonesia"
                    />
                    <IoIosArrowDown
                      size={24}
                      color={`${effectiveIsScrolled ? "#244563" : "white"}`}
                      className="transition-all duration-300 ease-in-out"
                    />
                  </Space>
                </Dropdown>
              </div>
            </div>
          {/* ) : (
            <div />
          )} */}
        </div>
        {/* )} */}
        {/* {!isMobile && ( */}
        {/* <>
            <div className="flex flex-row items-center justify-start w-5/6 lg:gap-12 xl:gap-20">
              <Link className="cursor-pointer w-56 h-auto" href={"/"}>
                {isScrolled ? (
                  <Image
                    src="/image/logoUmkm4.svg"
                    alt="UMKM Logo"
                    className="w-56"
                    width={100}
                    height={100}
                    priority
                  />
                ) : (
                  <Image
                    src="/image/logoUmkm4_white.svg"
                    alt="UMKM Logo"
                    className="w-56"
                    width={100}
                    height={100}
                    priority
                  />
                )}
              </Link>
              <div className="flex flex-row justify-start items-center gap-7 w-full">
                {nav.map((menuItem, index) => (
                    <Link
                      key={index}
                      className={`font-medium ${
                        isScrolled ? "" : "text-white"
                      } hover:text-cust-orange transition-all duration-300 ease-in-out`}
                      href={menuItem.url_menu}
                    >
                      {locale === "id"
                        ? menuItem.nama_menu
                        : menuItem.nama_menu_en}
                    </Link>
                  ))}
              </div>
            </div>
            <div className="flex flex-row justify-end items-center w-1/6 gap-5">
              <div className="flex flex-row gap-2 items-center cursor-pointer">
                <Dropdown
                  menu={{
                    items,
                    onClick: ({ key }) => setLocale(key),
                  }}
                >
                  <Space>
                    <Image
                      src={localeFlag}
                      width={28}
                      height={28}
                      alt="indonesia"
                    />
                    <IoIosArrowDown
                      size={28}
                      color={`${isScrolled ? "#244563" : "white"}`}
                      className="transition-all duration-300 ease-in-out"
                    />
                  </Space>
                </Dropdown>
              </div>
            </div>
          </> */}
        {/* )} */}
      </header>

      {/* Overlay */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black/60 z-40 transition-all duration-300 ease-in-out"
          onClick={closeSidebar}
          aria-label="Close sidebar overlay"
        />
      )}

      {/* Sidebar */}
      <div
        ref={sidebarRef}
        className={`fixed top-0 left-0 h-full w-64 bg-cust-blue text-white z-50 transform transition-transform duration-300 ease-in-out ${
          isOpen ? "translate-x-0" : "-translate-x-full"
        }`}
      >
        <div className="p-4 flex justify-end z-50">
          <button
            onClick={toggleSidebar}
            className="text-white focus:outline-none cursor-pointer"
            aria-label="Close Sidebar"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M6 18L18 6M6 6l12 12"
              ></path>
            </svg>
          </button>
        </div>

        <nav className="mt-4 z-50">
          <ul className="">
            {nav
              .filter((item) => item.nama_menu !== "language_active")
              .map((item, index) => (
                <li key={index} className="mb-0">
                  <Link
                    href={item?.url_menu}
                    className="flex items-center justify-between px-6 py-3 hover:bg-cust-orange transition-colors duration-300"
                    onClick={toggleSidebar}
                  >
                    <span>
                      {locale === "id" ? item?.nama_menu : item?.nama_menu_en}
                    </span>
                    {item?.hasSubmenu && (
                      <svg
                        className="w-4 h-4"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M9 5l7 7-7 7"
                        ></path>
                      </svg>
                    )}
                  </Link>
                </li>
              ))}
            <hr className="rounded-full w-auto h-[1px] mx-6 my-3" />
            <li>
              <a
                href={`https://wa.me/${whatsapp}?text=${encodeURIComponent(
                  "Hello, UMKM!."
                )}`}
                target="_blank"
                rel="noopener noreferrer"
                className="flex flex-row items-center justify-start px-6 py-3 gap-1.5 hover:bg-cust-orange transition-colors duration-300"
                aria-label="WA Center"
              >
                <div className="relative h-7 w-7">
                  <Image
                    src={"/whatsapp.svg"}
                    alt="whatsapp"
                    width={24}
                    height={24}
                    className="hover:opacity-80"
                  />
                </div>
                <div>WA Center</div>
              </a>
            </li>
            {nav.some((item) => item.nama_menu === "language_active") && (
              <li className="flex flex-row justify-start gap-5">
                <div className="flex flex-row gap-2 items-center cursor-pointer w-full">
                  <Dropdown
                    menu={{
                      items,
                      onClick: ({ key }) => setLocale(key),
                    }}
                    className="px-6 py-3 items-center w-full hover:bg-cust-orange transition-colors duration-300"
                  >
                    <Space>
                      <Image
                        src={localeFlag}
                        width={24}
                        height={24}
                        alt="locale flag"
                      />
                      {locale === "id" ? "Indonesia (ID)" : "English (EN)"}
                      <IoIosArrowDown
                        size={24}
                        color={"white"}
                        className="transition-all duration-300 ease-in-out"
                      />
                    </Space>
                  </Dropdown>
                </div>
              </li>
            )}
          </ul>
        </nav>
      </div>
    </>
  );
};

export default Header;
